export default "__VITE_PUBLIC_ASSET__1ede5d64__"